import React from 'react'
import { BottomSection } from '../../components/entity-panel/sections/'
import { CompareCredit } from '../../../types'

export default function CardDetails(props: {
  card: CompareCredit.FormattedCard
  orderId: string
  view: 'list' | 'details' | 'modal'
  isCollapsed?: boolean
}) {
  const { card, orderId, view, isCollapsed } = props
  const [collapsed, setCollapsed] = React.useState(
    view === 'list' ? isCollapsed : false,
  )

  return (
    <div className="c-card-tile__details-inner / pt-6 md:pt-8 px-4 xs:px-6 md:pb-4 lg:px-0">
      <BottomSection
        orderId={orderId}
        entity={card}
        setCollapsed={setCollapsed}
        isCollapsed={view === 'list' ? collapsed : false}
        view={view}
      />
    </div>
  )
}
